'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function AddressInfo() {
  this.extends = [_AccountController];
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.history = new History();
  this.analytics = new Analytics();
  this.dataSanitization = new DataSanitization();

  this._onFormSubmitCallback = null;
  this.formAction = 'account.create_member_address';
  this.formValues = ''; // used to compare initial values with values when form submit to see if user submit form via coanada psot via manual
  this.provincePostalCode = null;
  this.canadaPostID = null;

  this.init = function () {
    this._super();

    // failed min reqs or completed steps in this set
    if (!this.hasVerifiedEmail() || !this.hasAllBasicInfo() || this.hasAllProfileInfo() || this.hasAddress()) {
      this.routeToNextStep();
      return;
    }

    this._$node = $(this.node);

    // Cache the form
    this._$form = this._$node.find('.js--onboarding-form');
    // Province select
    this.selectedItem = document.querySelector('.textLabel');
    // Form inputs
    this._$formInputs = {
      address: this._$node.find('.js--form-address'),
      province: this._$node.find('.js--form-province'),
      streetNumber: this._$node.find('.js--form-street-number'),
      streetName: this._$node.find('.js--form-street-name'),
      city: this._$node.find('.js--form-city'),
      suite: this._$node.find('.js--form-suite'),
      country: this._$node.find('.js--form-country'),
      postalCode: this._$node.find('.js--form-postal-code'),
      submit: this._$node.find('.js--form-submit'),
      // Initially, only the address search field is visible
      // Once user searches for address, then the rest become
      // un-hidden
      hiddenField: this._$node.find('.hidden-address-field')
    };

    this._$cantFindAddressText = this._$node.find('.cant-find-address');
    this._$addressFieldsPrompt = this._$node.find('.address-fields-prompt');
    this._$cantFindAddressLink = this._$cantFindAddressText.find('.cant-find-address-link');
    this._$canadaPostIdHiddenField = this._$node.find('.js--form-canada-post-id');

    this._onFormSubmitCallback = this.presenter.addCallbackToAction(this.formAction, this.onFormSubmittedCallback.bind(this));
  };

  this.initAllReady = function () {
    this._setupCanadaPostAutocomplete();
  };

  this._setupCanadaPostAutocomplete = function () {
    var _this2 = this;

    this.cpAutoComplete = new CanadaPostAutocomplete(this._$form);

    var _this = this;

    // Needed to add custom validations to form action
    _this._extendPresenter();

    /*
      This attribute gets un-set at some point, so ensure this is set, needed for
      disabling chrome auto-complete overlapping canada post autocomplete 
      Ref:
        https://stackoverflow.com/questions/15738259/disabling-chrome-autofill
        https://github.com/bcgov/entity/issues/661
    */
    this._$formInputs.address.attr('autocomplete', 'chrome-off');

    // When province changes, reset old validations
    // From previous potential postal code validation messages
    this._$formInputs.province.change(function () {
      _this2.cpAutoComplete.resetFormValidations();
    });

    // Listener for when inputs are filled out by CP
    this.cpAutoComplete.control.listen('populate', function (address) {
      _this2.cpAutoComplete.resetFormValidations();

      // Update select field to province provided by CP
      // CP doesn't fill out select html elements so need to do manually
      _this2._$formInputs.province.val(address.ProvinceCode).change();

      // If po box number present in CP address response
      // set street number as po box number
      // and street name as po box
      if (address.POBoxNumber && !address.BuildingNumber && !address.Street) {
        _this2._$formInputs.streetNumber.val(address.POBoxNumber);
        _this2._$formInputs.streetName.val('PO Box');
      }

      _this.canadaPostID = address.Id;

      // Show hidden fields, update tet
      _this2._$addressFieldsPrompt.removeClass('hide').text('Confirm your address');
      _this2._$formInputs.hiddenField.removeClass('hide');

      // Clear address before serialize
      _this2._$formInputs.address.val('');

      // Serialize Form (Save all form values as string)
      // Using this string, set this.formValues var for comparison later
      _this.formValues = _this2._$form.serialize();

      // Make the search address field update with the full formatted address
      _this2._$formInputs.address.val(address.FormattedLine1);
    });

    // Listener for if user clicks cant find address
    this._$cantFindAddressLink.click(function () {
      // Make the search address field blank
      _this2._$formInputs.address.val('');
      _this2._$formInputs.province.val('');
      _this2._$formInputs.streetNumber.val('');
      _this2._$formInputs.streetName.val('');
      _this2._$formInputs.city.val('');
      _this2._$formInputs.suite.val('');
      _this2._$formInputs.postalCode.val('');
      _this2.selectedItem.removeClass('selected-item');
      _this2.selectedItem.innerHTML = 'Province';
      _this2._$addressFieldsPrompt.removeClass('hide').text('Manually type your address');
      _this2.cpAutoComplete.resetFormValidations();
      _this2._$formInputs.hiddenField.removeClass('hide');
      _this2._$formInputs.country.val('Canada');
    });

    // Click Submit
    this._$formInputs.submit.click(function () {
      var isFormFieldsHidden = _this2._$formInputs.hiddenField.hasClass('hide');
      var isAddressSearchEmpty = !_this2._$formInputs.address.val();
      // Only the address search field is visible (initial state)
      if (isAddressSearchEmpty && isFormFieldsHidden) {
        _this2._$form.mogo().setErrorForValidationField('address', 'Please enter an address');
      } else {
        // ensure address field is empty when submitting
        _this2._$formInputs.address.val('');
      }
    });
  };

  this._extendPresenter = function () {
    // Bind custom validations to the form action / ie when form is submit
    this.presenter.extendCustomValidations('account.create_member_address', {
      _hooks: {
        // Call this posthook method to trigger validation errors
        posthook: this._posthook.bind(this)
      },
      apartment: {
        sanitize: function sanitize(value) {
          if (value === undefined) {
            return '';
          }
          return value;
        }
      }
    });
  };

  this._posthook = function () {
    var formValues = this._$form.serialize();
    var province = this._$formInputs.province.val();
    var postalCode = this._$formInputs.postalCode.val();
    var firstCharPostalCode = postalCode.charAt(0);
    var notEmpty = province && postalCode && this.cpAutoComplete.postalCodeMap[province];

    // Check if postal code is from selected province
    // Else throw validation error
    if (notEmpty) {
      if (!this.cpAutoComplete.postalCodeMap[province].firstLetter.includes(firstCharPostalCode)) {
        this._$form.mogo().setErrorForValidationField('postal_zip_code', "The postal code doesn't look to be from the province you have provided");
      }
    }

    // If form values before submitting match what was filled out by
    // CP, then no changes were made, in this case , send in a
    // Canada_post_id to BE (add val to hidden canada_post_id field)
    // If changes were made (form values dont match), then don't send
    // Canada_post_id to BE.
    if (this.formValues === formValues) {
      this._$canadaPostIdHiddenField.val(this.canadaPostID);
    }

    this.presenter.extendViewMap({
      'account.apartment': {
        set: function set(val) {
          if (!val) return '';
          return val;
        }
      }
    });

    // remove address field
    delete this.presenter._viewMap['account.address'];
  };

  this.onFormSubmittedCallback = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
      var _window, analytics, uuid, street, city, postalCode, _data$country, country, province, suite, addressObj, analyticsData, analyticsRequest, formAnalyticsID;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.isGeneralConnectionIssue(data, response)) {
                _context.next = 4;
                break;
              }

              this.invokeConnectionIssuePage(this._$form, {
                productLabel: 'MogoMember'
              });
              _context.next = 31;
              break;

            case 4:
              if (!(data && data.errors && data.errors[0].code == 400)) {
                _context.next = 8;
                break;
              }

              $('#Notification').mogo().get();
              _context.next = 31;
              break;

            case 8:
              if (!(response === 200)) {
                _context.next = 30;
                break;
              }

              _window = window, analytics = _window.analytics;
              uuid = data.uuid, street = data.address, city = data.city, postalCode = data.postal_code, _data$country = data.country, country = _data$country === undefined ? 'Canada' : _data$country, province = data.province, suite = data.suite;
              addressObj = {
                city: city,
                country: country,
                postalCode: postalCode,
                province: province,
                street: street,
                suite: suite
              };
              _context.prev = 12;
              _context.next = 15;
              return analytics.identify(uuid, {
                address: addressObj
              });

            case 15:
              _context.next = 17;
              return analytics.track('Flow Updated', {
                flow_id: 'onboarding',
                product_id: 'mogo',
                screen_name: 'onboarding address',
                member_address: street,
                member_city: city,
                member_province: province,
                member_postal_code: postalCode
              });

            case 17:
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context['catch'](12);

              console.warn('>>> Error: ' + _context.t0);

            case 22:
              analyticsData = this.analytics.constructData('Complete Address');
              analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);

              analyticsRequest.send();
              formAnalyticsID = $('.js--onboarding-form').data('analytics-id');

              this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
              this.presenter.models.account.updateModel(data, this.onCompletedStep.bind(this));
              _context.next = 31;
              break;

            case 30:
              console.warn(data, response);

            case 31:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[12, 19]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  this.onCompletedStep = function () {
    this.routeToNextStep(); // _OnboardingCoordinator
  };

  this.destroy = function () {
    if (this._$form) {
      // cleanup required object so its ready for the next screen
      delete this._$form.mogo().schema.required;
      if (this._onFormSubmitCallback) {
        this.presenter.removeCallbackFromAction(this.formAction, this._onFormSubmitCallback);
      }
    }
  };
}